var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"root d-inline-block"},[_c('toggle-button',{attrs:{"value":!_vm.isActive,"color":"#82C7EB","width":70,"height":25,"sync":true,"labels":{checked: 'ویرایش', unchecked: 'ویرایش'}},on:{"change":_vm.btnClicked}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }